<template>
  <Cmodal
      v-model="show"

      
      centered
      size="lg"
      title="Other Pay"
      :tag="false"
      :progressing="loading"
      @hide="hide"
      @submit="submit"
    >
        <b-col>

            <b-row class="d-flex flex-row justify-content-center">
                <p v-if="isNaN(Total)" class="mb-0 h5 font-weight-bold text-dark">Total Payable: <b-spinner class="mb-2" small label="Medium Spinner"></b-spinner> </p>
                <p v-else class="mt-3 h5 font-weight-bold text-dark">Total Payable: $<span>{{ Total.toFixed(2) }}</span></p>
            </b-row>
            <b-row class=" mt-2 d-flex flex-row justify-content-center">
                <p class="font-lg"> Please confirm the payable amount, select the payment source,  and continue with payment.</p>
            </b-row>
            <b-row class="d-flex flex-row justify-content-center flex-wrap px-3 mb-3">
                <b-btn
                    v-for="option in otherPayList"
                    :key="option.value"
                    class="m-2 other-pay-btn"
                    :class="otherPaySource === option.value ? 'activeBtn' : 'deactiveBtn'"
                    @click="selectOtherPay(option.value)"
                >
                    {{ option.item }}
                </b-btn>
            </b-row>
            <b-row class="d-flex flex-row justify-content-center px-3 mt-4 mb-2">
                <b-input-group prepend="Reference ID" >
                    <b-input
                        v-model="ReferenceID"
                        name="Reference ID"
                        :disabled="loading"
                        placeholder="Optional"
                        style="font-size: 1.15rem !important;"
                    />
                </b-input-group>
            </b-row>
  
            <b-row class="d-flex flex-row justify-content-center" v-if="err">
                <p class="font-lg text-danger">Please select a payment Source</p>
            </b-row>
        </b-col>
        <template #actions="{ submit, hide }">
        <b-row class="flex-grow-1">
          <b-col cols="6">
            <b-btn variant="warning" :disabled="loading" block class="text-nowrap credit-modal-btn" @click="submit">
              <span v-if="loading">
                Processing...
                <b-spinner small class="ml-2 mb-2" label="Loading..."></b-spinner>
              </span>
              <span v-else>
                Continue with Payment 
              </span>
    
            </b-btn>
          </b-col>
          <b-col cols="6">
            <b-btn variant="danger" block class="text-nowrap credit-modal-btn cancel-btn-cmodal" @click="hide">
                Cancel
            </b-btn>
          </b-col>
        </b-row>
      </template>    </Cmodal>
</template>

<script>
import Cmodal from '../../shared/Cmodal.vue';
export default {
    name:"otherPay",
    components:{
        Cmodal
    },
    props:{
        open:{type:Boolean, required:true},
        Total:{required:true},
        otherPaySources:{type:Array, required:true}
        
    },  
    data(){
        return{
            show:false,
            loading:false,
            otherPaySource:null,
            otherPayList:[],
            err:false,
            ReferenceID:null
        }
    },
    created(){
        this.otherPayList = this.otherPaySources.map(source => ({item: source[1], value: source[0]}));
        if(this.otherPayList.length === 1){
            this.otherPaySource = this.otherPayList[0].value
        }
        setTimeout(()=>{
            this.show = this.open
        },10)
    },
    methods:{
        selectOtherPay(value){
            if(this.loading){
                return
            }
            this.otherPaySource = value
        },
        submit(){
            if(isNaN(this.Total)){
                return 
            }
            this.err = false
            if(this.otherPaySource === null && this.otherPayList.length > 0){
                return this.err = true
            }
            
            this.loading=true
            if(this.ReferenceID){
                this.$emit("setReferenceID",this.ReferenceID)
            }
            if(this.otherPaySource){
                this.$emit("setOtherPaySource",this.otherPaySource)
            }
            this.$emit("submit")
            return
        },
        hide(){
            if(!this.loading){
                this.$emit("cancel")
                return console.log("called hide")
            }
        },
        cancel(){
            if(!this.loading){
                this.$emit("cancel")
                return console.log("called cancel")
            }
        }
    }
}
</script>

<style scoped>
div.input-group-text {
    font-size: 1.15rem !important;
}
.activeBtn {
    background: #f5c31d !important;
    border-color: #c8ced3 !important;
    color: #000 !important;
}
.deactiveBtn {
    background: #fff !important;
    border-color: #5b5f62 !important;
    color: #5b5f62 !important;
}
.other-pay-btn {
    min-width: 10rem;
    font-size: 1.5rem;
}
</style>